import api from "./api";

class QuoteService {
    search(term, params = {}) {
        return api.get("/api/quotes/", { params: { search: term, ...params } });
    }

    list(params = {}) {
        return api.get("/api/quotes/", { params });
    }

    get(id) {
        return api.get(`/api/quotes/${id}/`);
    }

    getContacts(id) {
        return api.get(`/api/quotes/${id}/contacts/`);
    }
}

export default new QuoteService();
